/* eslint-disable no-nested-ternary */
import { faAngleDoubleDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import PublishIcon from '@mui/icons-material/Create';
import MapIcon from '@mui/icons-material/Map';
import { useRouter } from 'next/router';
import React, { useState } from 'react';
import ProgressiveImage from 'react-progressive-image';
import { getBudgetScore } from '../../helpers/budgetScore';
import { getUser } from '../../helpers/token';
import Link from '@mui/material/Link';
import CountryEmoji from '../Destinations/CountryEmoji';
import PopularDestinationsPopup from '../Destinations/PopularDestinationsPopup';
import LoginButton from '../Header/LoginButton';
import FollowButton from '../Profile/FollowButton';
import BlurHashCanvas from './BlurHashCanvas';
import EditLocationDetails from './EditLocationDetails';
import TopicSelector from './TopicSelector';

const PhotoHeader = props => {
  const {
    title,
    description,
    image,
    query,
    countrySlug,
    tag,
    subtitle,
    countryName,
    locationDetails,
    isMobileFullPage,
  } = props;

  const [open, setOpen] = useState(false);

  const router = useRouter();

  const handlePublishClick = () => {
    const isLoggedIn = getUser();
    if (isLoggedIn) router.push(`/dashboard/publish?community=${props.tag}`);
    else setOpen(true);
  };

  let mapLink = `/map?search=${title}`;
  if (props.communityTag) {
    if (props.lang && props.lang !== 'en')
      mapLink = `/map?language=${props.lang}`;
    else mapLink = `/map?community=${props.tag.substring(5, 11)}`;
  }

  const innerCard = (
    <>
      <div
        className={`container h-100${props.topMargin ? ' tw-pt-[65px]' : ''}`}
      >
        <div
          className={`row h-100${
            isMobileFullPage ? ' fullpage-header' : ' photo-header'
          } justify-content-center`}
        >
          <div className="col-xl-7 col-lg-8 col-md-9 col-sm-10 col-12 my-auto">
            {props.query.countryCode &&
              !props.query.subdivision &&
              !props.query.city && (
                <div className="pb-2">
                  <CountryEmoji countryCode={props.query.countryCode} isFlag />
                </div>
              )}
            <Typography
              variant="h6"
              align="center"
              className="text-light font-weight-bold"
              style={{
                textShadow: '1px 1px 20px #343A40',
              }}
              component="h5"
            >
              {
                // For cities, display breadcrumbs to Country and Subdivison. Else, display Knowledge Graph subtitle, if unavailable country name
                (tag && props.communityTag ? '' : `${tag ? `#${tag}` : ''}`) ||
                  (query.city && (
                    <span>
                      <Link
                        color="textPrimary"
                        href={`/destinations/${countrySlug}/`}
                      >
                        <span className="text-light font-weight-bold">
                          {countryName}
                        </span>
                      </Link>
                      <span className="text-light">
                        {' '}
                        &raquo;{' '}
                        <Link
                          color="textPrimary"
                          href={`/destinations/${countrySlug}/${query.subdivision}`}
                        >
                          <span className="text-light font-weight-bold">
                            {query.subdivision}
                          </span>
                        </Link>
                      </span>{' '}
                    </span>
                  )) ||
                  (((query.search && !query.countryCode) ||
                    query.subdivision ||
                    query.city) && (
                    <Link
                      color="textPrimary"
                      href={`/destinations/${countrySlug}/`}
                    >
                      <span className="text-light font-weight-bold">
                        {subtitle}
                      </span>
                    </Link>
                  ))
              }
              {!props.noEdit && (
                <EditLocationDetails
                  countryCode={props.query.countryCode}
                  subdivision={props.query.subdivision}
                  city={props.query.city}
                  tag={tag}
                  data={locationDetails || { title, description, image }}
                />
              )}
            </Typography>
            <Typography
              gutterBottom
              variant="h2"
              component="h1"
              className="text-light font-weight-bold text-center"
              style={{
                textShadow: '1px 1px 10px #343A40',
              }}
            >
              {title}
            </Typography>
            <Typography
              gutterBottom
              className="lead text-light text-center"
              variant="h6"
              style={{
                textShadow: '1px 1px 10px black',
              }}
            >
              <em>
                {description ||
                  (locationDetails && locationDetails.description) || (
                    <>
                      <br />
                      <br />
                    </>
                  )}
              </em>
            </Typography>
            <div className="text-center">
              {props.communityTag && (
                <>
                  <div className="d-none d-xl-block d-lg-block d-md-block d-sm-none">
                    <FollowButton
                      btnstyle="solid"
                      community={parseInt(tag.substring(5, 11))}
                    />
                    <span
                      onClick={handlePublishClick}
                      onKeyPress={handlePublishClick}
                      role="button"
                      tabIndex={0}
                    >
                      <Button variant="contained" color="primary">
                        <PublishIcon />
                        <span className="pl-2">Publish</span>
                      </Button>
                    </span>
                  </div>
                  {open && (
                    <LoginButton
                      open={open}
                      hideButtons
                      onClickClose={() => setOpen(false)}
                      text=" and write your own travel blog"
                    />
                  )}
                </>
              )}
              {(props.communityTag || !tag) && (
                <>
                  <Link href={mapLink}>
                    <Button className="m-2" variant="contained" color="primary">
                      <span className="pr-1">Explore the map</span>
                      <MapIcon />
                    </Button>
                  </Link>
                </>
              )}
              {locationDetails &&
                locationDetails.sublocations &&
                locationDetails.sublocations.length > 1 && (
                  <PopularDestinationsPopup
                    title={title}
                    countrySlug={countrySlug}
                    subdivision={query.subdivision}
                    destinations={locationDetails.sublocations}
                  />
                )}
              {locationDetails && locationDetails.budgetScore && (
                <Tooltip
                  title={getBudgetScore(locationDetails.budgetScore, title)}
                >
                  <Typography
                    component="p"
                    variant="h4"
                    className="pt-2 text-light font-weight-bold"
                  >
                    {'$'.repeat(locationDetails.budgetScore)}
                  </Typography>
                </Tooltip>
              )}
            </div>
          </div>
          {isMobileFullPage && (
            <div className="col-12 read-more-icon my-auto">
              <div className="d-flex justify-content-center">
                <a href="#posts">
                  <IconButton
                    className="text-light"
                    aria-label="Scroll down"
                    size="large"
                  >
                    <FontAwesomeIcon
                      style={{ width: '40px', height: '40px' }}
                      icon={faAngleDoubleDown}
                    />
                  </IconButton>
                </a>
              </div>
            </div>
          )}
        </div>
        <div id="posts" />
      </div>
      <div
        className="text-mutedlight text-right pr-1"
        style={{ fontSize: '0.8rem' }}
      >
        {locationDetails && locationDetails.url && (
          <span>
            Description by{' '}
            <a
              className="text-mutedlight text-decoration-underline"
              target="_blank"
              rel="nofollow noreferrer noopener"
              href={locationDetails && locationDetails.url}
            >
              Wikipedia
            </a>{' '}
            under{' '}
            <a
              className="text-mutedlight text-decoration-underline"
              target="_blank"
              rel="nofollow noreferrer noopener"
              href={locationDetails && locationDetails.license}
            >
              CC BY-SA 3.0
            </a>
            .{' '}
          </span>
        )}
        {locationDetails && locationDetails.attribution && (
          <span>
            Photo:{' '}
            {(locationDetails && locationDetails.unsplashUser && (
              <a
                className="text-mutedlight text-decoration-underline"
                target="_blank"
                rel="nofollow noreferrer noopener"
                href={`https://unsplash.com/@${
                  locationDetails && locationDetails.unsplashUser
                }?utm_source=TravelFeed&utm_medium=referral`}
              >
                {locationDetails && locationDetails.attribution}
              </a>
            )) || (
              <span className="text-mutedlight">
                {locationDetails && locationDetails.attribution}
              </span>
            )}{' '}
            {locationDetails && locationDetails.unsplashUser && (
              <span>
                /{' '}
                <a
                  target="_blank"
                  rel="nofollow noreferrer noopener"
                  href="https://unsplash.com/?utm_source=TravelFeed&utm_medium=referral"
                  className="text-mutedlight text-decoration-underline"
                >
                  Unsplash
                </a>
              </span>
            )}
          </span>
        )}
      </div>
      <style jsx global>{`
        .read-more-icon {
          display: none;
        }
        .photo-header {
          min-height: 400px;
        }
        .fullpage-header {
          min-height: 500px;
        }
        @media (max-width: 992px) {
          .fullpage-header {
            min-height: calc(100vh - 137px);
          }
          .read-more-icon {
            display: block;
          }
        }
      `}</style>
    </>
  );
  const loadedCard = (
    <div
      className="w-100"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.3),rgba(0, 0, 0,0.5)),
url("${image}")`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
        backgroundSize: 'cover',
        minHeight: '400px',
      }}
    >
      {innerCard}
    </div>
  );

  const CardWithBlurHash = ({ children }) => (
    <BlurHashCanvas hash={locationDetails.blurHash} width={1920} height={400}>
      {children}
    </BlurHashCanvas>
  );

  return (
    <>
      {locationDetails && !locationDetails.image ? (
        locationDetails.blurHash ? (
          <CardWithBlurHash>{innerCard}</CardWithBlurHash>
        ) : (
          loadedCard
        )
      ) : (
        <ProgressiveImage
          src={image}
          placeholder={
            <>
              {locationDetails && locationDetails.blurHash ? (
                <CardWithBlurHash>{innerCard}</CardWithBlurHash>
              ) : (
                loadedCard
              )}
            </>
          }
        >
          {(src, imgloading) => {
            if (imgloading && locationDetails && locationDetails.blurHash) {
              return <CardWithBlurHash>{innerCard}</CardWithBlurHash>;
            }
            if (imgloading) {
              return (
                <>
                  <div
                    className="MuiSkeleton-rect w-100 MuiSkeleton-animate"
                    style={{
                      minHeight: '400px',
                      backgroundColor: 'rgba(0, 0, 0, 0.08)',
                    }}
                  >
                    {innerCard}
                  </div>
                </>
              );
            }
            return (
              <>
                {locationDetails && locationDetails.blurHash ? (
                  <CardWithBlurHash>{loadedCard}</CardWithBlurHash>
                ) : (
                  loadedCard
                )}
              </>
            );
          }}
        </ProgressiveImage>
      )}
      {locationDetails && locationDetails.topics && (
        <TopicSelector
          topics={locationDetails.topics}
          active={props.topic}
          onChange={props.setTopic}
        />
      )}
    </>
  );
};

export default PhotoHeader;
